<template>
    <div class="order_payment_container">
        <!-- 顶部导航 -->
        <div class="nav_header">
            <p class="nav_box pc">{{ $t('index.youAreHere') }}：{{ navTitle }} </p>
            <p class="back_btn" @click="goBack"  v-if="!orderId">
                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/返回.png" alt="" />
                 {{ $t('selectAge.back') }}
            </p>
            <p class="nav_box mo">{{$t('index.youAreHere')}}：{{ navTitle }}</p>
        </div>
        <div class="order_content">
            <!-- 左侧订单详情 -->
            <div class="order_details_section">
                <div class="section_header">
                    <div>
                        <div class="exam_type_tag">
                            {{ $t("payment.type") }}
                        </div>
                        <h2 class="section_title" v-if="examObj">
                            {{
                                currentLocale === "zh-CN"
                                    ? examObj.title
                                    : examObj.titleEn
                            }}
                        </h2>
                    </div>
                    <div class="payment_status status_unpaid">
                        <span v-if="status === 1" >{{currentLocale === 'zh-CN' ? '待支付' : 'Pending payment'}}</span>
                        <span v-if="status === 3" >{{currentLocale === 'zh-CN' ? '已过期' : 'Expired'}}</span>
                        <span v-if="status === 4" >{{currentLocale === 'zh-CN' ? '已退考' : 'Retired from the exam'}}</span>
                        <span v-if="status === 6" >{{currentLocale === 'zh-CN' ? '已取消' : 'Cancelled'}}</span>
                        <span v-if="!status"> {{ $t('payment.unpaid') }}</span>
                    </div>
                </div>

                <!-- 个人信息 -->
                <div class="personal_info_section">
                    <div class="action_buttons">
                        <p class="info">{{ $t("payment.personTitle") }}</p>
                        <p
                            class="edit_info_btn"
                            @click="editInfo"
                            v-if="!orderId"
                        >
                            {{ $t("payment.modify") }}
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/detail.png" alt="" />
                        </p>
                    </div>
                    <!-- 表格主体 -->
                    <div class="info_table" v-if="formData">
                        <div class="table_pair pair-col1">
                            <div class="table_cell table_cell_label">
                                {{ $t("studentInfo.credentialType") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ getCredentialTypeName(formData.credentialType) }}
                            </div>
                        </div>
                        <div class="table_pair pair-col2">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.lastNamePy") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.lastNamePy }}
                            </div>
                        </div>
                        <div class="table_pair pair-col1">
                            <div class="table_cell table_cell_label">
                                {{ $t("studentInfo.document") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.passport }}
                            </div>
                        </div>
                        <div class="table_pair pair-col2">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.firstNamePy") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.firstNamePy }}
                            </div>
                        </div>
                        <div class="table_pair pair-col1">
                            <div class="table_cell table_cell_label">
                                {{ $t("studentInfo.weChatID") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.WeChat }}
                            </div>
                        </div>
                        <div class="table_pair pair-col2">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.email") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.email }}
                            </div>
                        </div>
                        <div class="table_pair pair-col1">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.lastName") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.lastName }}
                            </div>
                        </div>
                        <div class="table_pair pair-col2">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.birthDate") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formattedBirthDate }}
                            </div>
                        </div>
                        <div class="table_pair pair-col1">
                            <div class="table_cell table_cell_label">
                                {{ $t("payment.firstName") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.firstName }}
                            </div>
                        </div>
                        <div class="table_pair pair-col2">
                            <div class="table_cell table_cell_label">
                                {{ $t("studentInfo.channelCode") }}
                            </div>
                            <div class="table_cell table_cell_value">
                                {{ formData.channelCode }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 提示信息 -->
                <div class="note_section">
                    <p class="note_img">
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/老师二维码.png" alt="" />
                    </p>
                    <p class="note_text">
                        <span> 
                            {{ $t("selectAge.addTeacher") }}
                         </span>
                        {{$t('payment.des')}}
                    </p>
                </div>
            </div>

            <!-- 右侧支付区域 -->
            <div class="payment_container">
                <!-- 标题 -->
                <div class="payment_title">
                    {{
                                currentLocale === "zh-CN"
                                    ? "报名费用"
                                    : "Registration Fee"
                            }}
                </div>

                <!-- 费用详情 -->
                <div class="fee_details">
                    <!-- 原价 -->
                    <div class="fee_row">
                        <div class="fee_label">{{
                                currentLocale === "zh-CN"
                                    ? "原价"
                                    : "Original Price"
                            }}</div>
                        <div
                            class="fee_value"
                            :class="payNumber.specialPrice ? 'original_price' : ''"
                            >
                            <!-- ￥{{ paymentData.originalPrice }} -->
                            {{ "¥" }}{{ payNumber.price }}
                        </div>
                    </div>

                    <!-- 优惠金额 -->
                    <div class="fee_row" v-if="payNumber.specialPrice">
                        <div class="fee_label">
                            {{
                                currentLocale === "zh-CN"
                                    ? "优惠金额"
                                    : "Discount Amount"
                            }}
                        </div>
                        <div class="fee_value discount_amount">
                            {{ " -¥" }}{{ payNumber.specialPrice }}
                        </div>
                    </div>
                    <!-- 渠道优惠 -->
                    <!-- <div class="fee_row" v-if="payNumber && payNumber.channelDiscount">
                        <div class="fee_label">
                            {{
                                currentLocale === "zh-CN"
                                    ? "渠道优惠金额"
                                    : "Channel Discount Amount"
                            }}
                        </div>
                        <div class="fee_value discount_amount">
                            {{ " -¥" }}{{ payNumber.channelDiscount }}
                        </div>
                    </div> -->
                    <!-- 分割线 -->
                    <div class="divider"></div>

                    <!-- 实付金额 -->
                    <div class="fee_row">
                        <div class="fee_label total_label">
                            {{
                                currentLocale === "zh-CN"
                                    ? "实付款"
                                    : "Amount Due"
                            }}
                        </div>
                        <div class="fee_value total_amount">
                            {{ "¥" }}{{ payNumber.finalPrice }}
                        </div>
                    </div>
                </div>

                <!-- 提示信息 -->
                <div class="payment_tips" v-if="!isCancel">
                    <p class="tip_text">
                        <!-- <span style="color: red"> 注： </span> -->
                        {{ $t("payment.tip1") }}
                        <!-- 付款成功后，将为您锁定考位。因报名人数较多，支付过程中可能出现名额不足的情况，如未能成功报名，系统将自动退款。 -->
                    </p>
                </div>

                <!-- 支付按钮 -->
                <div class="payment_actions">
                    <el-button
                        type="primary"
                        class="pay_now_button"
                        :loading="isPaying"
                        :disabled="isPaying"
                        @click="handlePayment"
                        v-if="!isCancel"
                    >
                        <!-- 现在支付￥{{ paymentData.actualPayment }} -->
                        {{
                            currentLocale === "zh-CN"
                                ? "确认并支付 ¥"
                                : "Confirm and pay ¥"
                        }}{{ payNumber.finalPrice }}
                    </el-button>

                    <el-button
                        class="cancel_order_button"
                        @click="cancelOrder(1)"
                        v-if="isFromOrder && !isCancel"
                    >
                        {{
                            currentLocale === "zh-CN"
                                ? "取消订单"
                                : "Cancel an order"
                        }}
                    </el-button>
                    <el-button
                        class="delete_order_button"
                        @click="cancelOrder(2)"
                        v-if="isFromOrder && isCancel"
                    >
                        {{
                            currentLocale === "zh-CN"
                                ? "删除订单"
                                : "Delete Order"
                        }}
                    </el-button>
                </div>
            </div>
        </div>
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            :show-delete-icon="true"
            show-size="small"
            @confirm="handleConfirm"
            @cancel="handleCancel"
        >
            <template #content>
                <div class="sure_pay_content">
                    <!-- <p class="p_text" v-if="false">
                        扫码支付
                        <span>720</span>
                        元
                    </p> -->
                    <p class="p_img">
                        <el-image  v-if="payImg"
                            :src="payImg"
                            :preview-src-list="[
                                payImg
                            ]">
                        </el-image>
                    </p>
                    <p class="p_text1">
                        {{ currentLocale === "zh-CN" ? "请使用支付宝或微信扫码完成支付" : "Please scan the QR code with Alipay or WeChat to complete your payment." }}
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/微信.png" alt="" />
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/支付宝.png" alt="" />
                    </p>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
        <Modal
            :showModal="showModal1"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-delete-icon="true"
            show-size="small"
            @confirm="handleConfirm1"
            @cancel="handleCancel1"
        >
            <template #content>
                <div class="cancel_pay_content">
                    <el-result icon="warning" class="result-image">
                        <template slot="extra">
                            <p class="cancel_text">
                                {{
                                    currentLocale === "zh-CN"
                                        ? "温馨提示"
                                        : "Reminder"
                                }}
                            </p>
                            <p
                                class="cancel_text1"
                                v-if="cancelOrderType === 1"
                            >
                                {{
                                    currentLocale === "zh-CN"
                                        ? "您确定要取消订单吗？"
                                        : "Are you sure you want to cancel the order?"
                                }}
                            </p>
                            <p
                                class="cancel_text1"
                                v-if="cancelOrderType === 2"
                            >
                                {{
                                    currentLocale === "zh-CN"
                                        ? "您确定要删除订单吗？"
                                        : "Are you sure you want to delete the order?"
                                }}
                            </p>
                        </template>
                    </el-result>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
        <Modal
            :showModal="showModal2"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-delete-icon="false"
            show-size="small"
            @confirm="handleConfirm2"
            @cancel="handleCancel2"
        >
            <template #content>
                <div class="cancel_pay_content">
                    <el-result icon="success" class="result-image">
                        <template slot="extra">
                            <p class="cancel_text">{{ $t('payment.descOne') }}</p>
                            <p class="cancel_text1">{{ $t('payment.descTwo') }}</p>
                        </template>
                    </el-result>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
        <Modal
            :showModal="showModal3"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-delete-icon="false"
            :confirmText="currentLocale === 'zh-CN' && timeNumber > 0  ? '倒计时' + timeNumber + 's' : currentLocale !== 'zh-CN' && timeNumber > 0 ? timeNumber + 's' + ' Remaining': $t('payment.ok')"
            show-size="small"
            @confirm="handleConfirm3"
        >
            <template #content>
                <div class="cancel_pay_content">
                    <el-result icon="warning">
                        <template slot="extra">
                            <p class="cancel_text2">{{$t('payment.des1')}}</p>
                        </template>
                    </el-result>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
    </div>
</template>
<script>
import Vue from "vue";
import {
    getExamRescource,
    getPayNumberRescource,
    getOrderDetailRescource,
    deleteOrder,
    cancelOrder,
    getPayRescorce,
    getOrderPayRescorce,
    queryOrderPayDetail
} from "@/plugins/api";
export default Vue.extend({
    data() {
        return {
            // infoData: {},
            navTitle: "",
            // 支付状态
            isPaying: false,
            showModal: false,
            showModal1: false,
            showModal2: false,
            status: "",
            formData: null,
            examId: "",
            examPositionId: "",
            examObj: {},
            positionObj: {},
            currentLocale: "zh-CN",
            isFromOrder: false,
            orderId: "", // 订单id
            payNumber: {},
            isCancel: false,
            showDeleteDialog: false,
            checkList: [],
            cancelOrderType: null,
            payImg: null,
            intervalId: null,
            intervalId1: null,
            showModal3: false,
            timeNumber: 5
        };
    },
    props: {},
    watch: {
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                this.navTitle = this.$route.meta && this.currentLocale === "zh-CN" ? this.$route.meta.title : this.$route.meta.titleEn;

            },
            immediate: true,
        },
    },
    components: {},
    mounted() {
    },
    destroyed() {
        clearInterval(this.intervalId);
        clearInterval(this.intervalId1);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        clearInterval(this.intervalId1);
    },
    computed: {
        // 格式化生日显示
        formattedBirthDate() {
            if (!this.formData.birthDate) return "";
            try {
                const date = new Date(this.formData.birthDate);
                if (isNaN(date.getTime())) return this.formData.birthDate;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");

                return `${year}-${month}-${day}`;
            } catch (error) {
                return this.formData.birthDate;
            }
        },
    },
    created() {
        this.currentLocale = this.$i18n.locale || "zh-CN";
        const options = this.$route.query;
        if (options.orderId) { // 订单详情
            this.isFromOrder = true;
            this.orderId = options.orderId;
            this.status = options.status * 1;
            this.getOrderDetail(this.orderId);
            this.isCancel = this.status * 1 === 1 ? false : true;
        } else {
            // 原有报名流程
            let payData = this.$store.state.auth.studentInfo;
            if (payData) {
                this.examId = payData.examId;
                this.examPositionId = payData.examPositionId;
                this.formData = payData.formData;
                this.positionObj = payData.positionObj;
                this.checkList = payData.checkList;
            }
            this.getExamList();
            // 新建的时候需要获取对应的展示支付信息
            // 如果是编辑返回，且有保存的支付信息，则使用保存的支付信息
            if (payData.payNumber) {
            	this.payNumber = payData.payNumber
            	this.isFromOrder = payData.isFromOrder
            	this.orderId = payData.orderId
            } else {
            	// 新建的时候需要获取对应的展示支付信息
            	this.getPayNumber()
            }
        }
    },
    methods: {
        goBack() {
            // 返回上一页逻辑
            this.$router.go(-1);
        },
        editInfo() {
            // 修改考试信息逻辑
            this.$router.push({
                path: "/registration/Information",
            });
            // this.$router.go(-1);
        },
        handlePayment() {
            this.showModal3 = true
			// 如果已有定时器，先清除，避免重复叠加
		    if (this.timer) {
			    clearInterval(this.timer)
			    this.timer = null
			}
			// 重置倒计时（比如 60 秒）
			this.timeNumber = 5
			this.timer = setInterval(() => {
			    this.timeNumber--
			    if (this.timeNumber <= 0) {
			      clearInterval(this.timer)
			      this.timer = null
			    }
			}, 1000)
        },
        handleConfirm3() {
            if (this.timeNumber !== 0) return
            this.showModal3 = false
            this.sureHandlePayment()
        },
        async sureHandlePayment() {
            // 处理支付逻辑
            try {
                let payParams = null;
                if (this.isFromOrder) {
                    // 订单详情跳转，直接用订单id
                    const data = {
                        id: this.orderId,
                        language: this.currentLocale,
                        isWeb: true
                    };
                    payParams = await getOrderPayRescorce(data);
                } else {
                    // 新建订单，组装参数
                    const params = {
                        // examId: this.examId,
                        passport: this.formData.passport,
                        WeChat: this.formData.WeChat,
                        // examPositionId: this.examPositionId,
                        firstName: this.formData.firstName,
                        lastName: this.formData.lastName,
                        firstNamePy: this.formData.firstNamePy,
                        lastNamePy: this.formData.lastNamePy,
                        email: this.formData.email,
                        birthDate: this.formData.birthDate,
                        examList: this.checkList,
                        positionObj: this.positionObj,
                        language: this.currentLocale,
                        credentialType: this.formData.credentialType,
                        isWeb: true
                    };
                    // 只有当 channelCode 有值时才添加该属性
                    if (this.formData.channelCode) {
                        params.channelCode = this.formData.channelCode;
                    } else if (sessionStorage.getItem("channelCode")) {
                        params.channelCode = sessionStorage.getItem("channelCode");
                    }
                    // console.log('新建', params);
                    payParams = await getPayRescorce(params);
                    // 新增：处理金额为0的情况
                    if (payParams.needPay === false) {
                        // 可以显示一个提示
                        this.$message({
                            message:
                                payParams.message ||
                                (this.currentLocale === "zh-CN"
                                    ? "订单创建成功"
                                    : "Order created successfully"),
                            type: "success",
                        });
                        // 延迟跳转，让用户看到提示
                        setTimeout(() => {
                            // 如果payParams中包含订单号，跳转到对应订单详情
                            if (payParams.code) {
                                this.$router.push(
                                    "/order?id=" + payParams.code
                                );
                            } else {
                                // 如果没有订单号，跳转到订单列表
                            }
                        }, 1000);

                        return; // 直接返回，不再执行后续支付逻辑
                    }
                }
                // 如果有订单号但金额为0的情况（从订单详情进入）
                if (payParams.needPay === false) {
                    this.$message({
                        message:
                            this.currentLocale === "zh-CN"
                                ? "此订单无需支付"
                                : "No payment required for this order",
                        type: "success",
                    });

                    return;
                }
                this.payImg = payParams.qrCodeStr ? payParams.qrCodeStr : "";
                
                const that = this
                this.orderId = payParams.orderId
                this.isFromOrder = true
                this.$store.dispatch("auth/updateStudentPartial", {
                    isFromOrder: true, // 添加来源标记
					orderId: this.orderId, // 保存订单ID
					payNumber: this.payNumber // 保存支付信息
                });
                this.showModal = true;
                // this.isPaying = true
                 if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
                this.intervalId = setInterval(function () {
                    that.getPayDetail(payParams.reqsn, payParams.orderId);
                }, 2000);
            } catch (err) {
                let msg =
                    this.currentLocale === "zh-CN"
                        ? "支付失败"
                        : "Update Failed";
                if (err && err.data && err.data.error) {
                    msg =
                        this.currentLocale === "zh-CN"
                            ? err.data.error.returnUserMessage ||
                              err.data.error.returnMessage
                            : err.data.error.returnUserMessageEn ||
                              err.data.error.returnMessageEn ||
                              err.data.error.returnMessage;
                }
                this.$message({
                    message: msg,
                    type: "error",
                });
            } finally {
            }
        },
        async getPayDetail(reqsn, orderId) {
            await queryOrderPayDetail({reqsn: reqsn, orderId:orderId})
                .then((res) => {
                    if (res.message === "交易成功" || res.message === "查询成功" ||  res.message === "支付成功") {
                        this.showModal2 = true;
                        this.isPaying = false
                        clearInterval(this.intervalId);
                    }
                    if (res.message === "已取消") {
                        this.isPaying = false
                         this.$router.push({
                            path: "/order",
                        });
                        clearInterval(this.intervalId);

                    }
                })
                .catch(() => {});
        },
        cancelOrder(type) {
            // 取消订单逻辑
            this.cancelOrderType = type;
            this.showModal1 = true;
        },
        deleteOrder() {},
        handleConfirm(result) {
            this.showModal = false;
        },
        handleCancel() {
            this.showModal = false;
        },
        async handleConfirm1(result) {
            let loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            try {
                if (this.cancelOrderType === 1) {
                    const res = await cancelOrder(this.orderId);
                    if (this.isFromOrder) {
                        this.$router.push({
                            path: "/order",
                        });
                        loading.close();
                    }
                } else {
                    await deleteOrder(this.orderId);
                    loading.close();
                    if (this.isFromOrder) {
                        this.$router.push({
                            path: "/order",
                        });
                    }
                }

                this.cancelOrderType = null;
            } catch (err) {
                let msg =
                    this.currentLocale === "zh-CN"
                        ? "删除失败"
                        : "Delete Failed";
                if (err && err.data && err.data.error) {
                    msg =
                        this.currentLocale === "zh-CN"
                            ? err.data.error.returnUserMessage ||
                              err.data.error.returnMessage
                            : err.data.error.returnUserMessageEn ||
                              err.data.error.returnMessageEn ||
                              err.data.error.returnMessage;
                }
                this.$message.error(msg);
                loading.close();
            } finally {
                loading.close();
                this.showModal1 = false;
            }
        },
        handleCancel1() {
            this.showModal1 = false;
            this.cancelOrderType = null;
        },
        handleConfirm2(result) {
            this.showModal1 = false;
            this.showModal2 = false
            this.$router.push({
                path: "/order",
            });
        },
        handleCancel2() {
            this.showModal1 = false;
            this.showModal2 = false
             this.$router.push({
                path: "/order",
            });
        },
        // 获取考试列表
        async getExamList() {
            const res = await getExamRescource();
            const listdata =
                typeof this.examId === "string"
                    ? JSON.parse(this.examId)
                    : this.examId;
            if (
                res.normal.length === listdata.length ||
                listdata.find((item) => item === 1)
            ) {
                this.examObj = res.composite[0];
            } else {
                const list = res.normal.filter((item) =>
                    listdata.find((item1) => item1 * 1 === item.id * 1)
                );
                let str = "";
                let str1 = "";
                list.forEach((item, index) => {
                    if (item.title) {
                        str +=
                            index === list.length - 1
                                ? item.title
                                : item.title + "+";
                    }
                    if (item.titleEn) {
                        str1 += item.titleEn;
                    }
                });
                let examObj = {
                    title: str,
                    titleEn: str1,
                };
                this.examObj = examObj;
            }
        },
        async getPayNumber() {
            const obj = {
                positionObj: this.positionObj,
                examList: this.checkList,
                channelCode: null,
            };

            if (this.formData.channelCode) {
                obj.channelCode = this.formData.channelCode;
            }
            const res = await getPayNumberRescource(obj);
            this.payNumber = res;
        },
        async getOrderDetail(orderId) {
            let loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const res = await getOrderDetailRescource(orderId);
            if (res) {
                console.log("订单详情:", res);
                let examObj = {
                    title: res.examTitle,
                    titleEn: res.examTitleEn,
                };
                this.examObj = examObj;
                // 组装 payData 结构

                this.formData = {
                    lastName: res.lastName,
                    firstName: res.firstName,
                    lastNamePy: res.lastNamePy,
                    firstNamePy: res.firstNamePy,
                    email: res.email,
                    phone: res.phone,
                    passport: res.passport,
                    WeChat: res.WeChat,
                    birthDate: res.birthDate ? res.birthDate : "",
                    channelCode: res.channelCode ? res.channelCode : "",
                    credentialType: res.credentialType
                        ? res.credentialType
                        : "",
                };
                this.$store.dispatch("auth/updateStudentPartial", {
                    examId: res.examIds,
                    examPositionId: res.positionInfo.id,
                    checkList: res.examList,
                    positionObj: res.positionInfo,
                    formData: this.formData,
                });
                // 将订单的金额进行展示
                this.payNumber = {
                    finalPrice: res.finalPrice,
                    price: res.price,
                    specialPrice: res.specialPrice,
                    channelDiscount: res.channelDiscount
                    // overduePrice: res.overduePrice,
                    // isOverdue: res.isOverdue
                };
                loading.close()
            }
        },
        getCredentialTypeName(type) {
            const typeMap = {
                '0': 'passport',
                '1': 'IDCard',
                '2': 'passport1',
                '3': 'passport2',
                '4': 'passport3',
                '5': 'passport4',
                '6': 'passport5',
                '7': 'passport6',
                '8': 'passport7',
                '9': 'passport8',
                '10': 'passport9'
            };
            const key = typeMap[type] || 'IDCard';
            return this.$t(`studentInfo.${key}`);
        },
    },
    beforeDestroy() {},
});
</script>
<style lang="stylus" scoped>
// // SCSS变量定义
$primary-color = #1677ff;
$primary-dark = #0958d9;
$text-color = #333;
$text-light = #666;
$text-lighter = #999;
$border-color = #e8e8e8;
$background-light = #fafafa;
$discount-color = #ff4d4f;
$success-color = #52c41a;
$warning-color = #faad14;
$error-color = #CA0000;
$white = #fff;
$shadow-light = 0 2px 8px rgba(0, 0, 0, 0.06);
$border-radius = 8px;
// 字体大小
$font-large = 18px;
$font-medium = 16px;
$font-normal = 14px;
$font-small = 12px;

.order_payment_container {
    min-height: calc(100vh - 620px);
    margin-bottom: 100px;
}

.nav_header {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;

    .nav_box {
        padding: 20px 0;
        font-size: 15px;
        color: #333;
    }

    .back_btn {
        display: flex;
        flex-flow: row;
        align-items: center;
        font-size: 15px;

        img {
            width: 20px;
            margin-right: 10px;
        }
    }

    .mo {
        display: none;
    }
}

.order_content {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
}

.order_details_section {
    flex: 1;
    min-width: 300px;
    background-color: $white;
    // height: 500px;
    border-radius: 10px;
}

.section_header {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-color;
    width: 100%;
    height: 60px;
    background: #011E41;
    border-radius: 10px 10px 0px 0px;
    padding: 18px 20px;
    > div {
        display: flex;
        flex-flow: row;
        align-items: center;
    }

    .section_title {
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 33px;
        margin-left: 10px;
    }

    .exam_type_tag {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        color: #011E41;
        padding: 3px 8px;
    }

    .payment_status {
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 33px;
    }

    .payment_status::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $success-color;
        margin-right: 4px;
    }

    .status_unpaid::before {
        background-color: $error-color;
    }
}

.personal_info_section {
    padding: 18px 20px 0 20px;

    .action_buttons {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;

        .info {
            font-size: 20px;
            color: #011E41;
            font-weight: bold;
            display: flex;
            flex-flow: row;
            align-items: center;
        }

        .info::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 22px;
            background: #011E41;
            background-color: $success-color;
            margin-right: 8px;
            background: #011E41;
        }

        .edit_info_btn {
            font-size: 18px;
            color: #0043E0;
            display: flex;
            flex-flow: row;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
                margin-left: 2px;
            }
        }
    }

    .info_table {
        border: 1px solid #9AB0B2;
        border-radius: 10px;
        overflow: hidden;
        margin: 20px 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: 1fr;

        .table_pair {
            display: flex;
            border-bottom: 1px solid #9AB0B2;

            &.pair-col1 {
                border-right: 1px solid #9AB0B2;
            }

            .table_cell {
                padding: 16px 18px;
                font-size: 16px;
                color: #011E41;
                display: flex;
                align-items: center;

                &.table_cell_label {
                    width: 120px;
                    flex-shrink: 0;
                    font-weight: 600;
                    color: #606266;
                    border-right: 1px solid #9AB0B2;
                    background-color: #CAD7D8;
                    text-align: left;
                    // justify-content: flex-end;
                    // white-space: nowrap;
                    word-break: break-word;
                }

                &.table_cell_value {
                    flex: 1;
                    color: #303133;
                    word-break: break-all;
                }
            }

            &.pair-col1:nth-of-type(1) { grid-column: 1; grid-row: 1; }
            &.pair-col2:nth-of-type(2) { grid-column: 2; grid-row: 1; }
            &.pair-col1:nth-of-type(3) { grid-column: 1; grid-row: 2; }
            &.pair-col2:nth-of-type(4) { grid-column: 2; grid-row: 2; }
            &.pair-col1:nth-of-type(5) { grid-column: 1; grid-row: 3; }
            &.pair-col2:nth-of-type(6) { grid-column: 2; grid-row: 3; }
            &.pair-col1:nth-of-type(7) { grid-column: 1; grid-row: 4; }
            &.pair-col2:nth-of-type(8) { grid-column: 2; grid-row: 4; }
            &.pair-col1:nth-of-type(9) { grid-column: 1; grid-row: 5; border-bottom: none; }
            &.pair-col2:nth-of-type(10) { grid-column: 2; grid-row: 5; border-bottom: none; }
        }
    }
}

.note_section {
    padding: 20px;
    display: flex;
    flex-flow: row;
    align-items: center;

    .note_img {
        img {
            width: 150px;
            height: 150px;
        }

        margin-right: 20px;
    }

    .note_text {
        max-width: 400px;
        display: flex;
        flex-flow: column;

        >span {
            max-width: 340px;
            // height: 36px;
            // line-height: 36px;
            padding: 10px 20px;
            background: #011E41;
            border-radius: 10px;
            color: $white;
            text-align: l;
            margin-bottom: 16px;
        }

        font-size: 16px;
        color: #011E41;
    }
}

// 右侧支付区域
.payment_container {
    max-width: 380px;
    min-width: 30%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    background: linear-gradient(180deg, #E6EFF9 0%, #FCFDFE 19%, #FCFDFE 100%);

    .payment_title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 30px;
        position: relative;
        padding-left: 12px;

        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -11px;
            width: 4px;
            height: 22px;
            background: #011E41;
            border-radius: 1.5px;
        }
    }

    .fee_details {
        margin-bottom: 60px;

        .fee_row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;

            &:last-of-type {
                margin-bottom: 0;
            }

            .fee_label {
                font-size: 16px;
                color: #606266;
                font-weight: 500;

                &.total_label {
                    font-size: 18px;
                    font-weight: 600;
                    color: #303133;
                }
            }

            .fee_value {
                font-size: 20px;
                font-weight: 500;

                &.original_price {
                    color: #909399;
                    text-decoration: line-through;
                }

                &.discount_amount {
                    color: #f56c6c;
                    font-weight: 600;
                }

                &.total_amount {
                    font-size: 20px;
                    font-weight: 600;
                    color: #f56c6c;
                }
            }
        }
    }

    .payment_tips {
        border-radius: 10px;
        padding: 24px 14px;
        margin-bottom: 30px;
        border: 1px solid #F5CDCD;
        background: #FFF7F7;

        .tip_text {
            font-size: 14px;
            color: #000;
            margin: 0;
        }
    }

    .payment_actions {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .pay_now_button {
            background: #0043E0;
            height: 50px;
            font-size: 20px;
            font-weight: 600;
            border-radius: 25px;
            transition: all 0.3s ease;

            &:hover, &:focus {
                background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
                box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
                transform: translateY(-2px);
            }

            &:active {
                transform: translateY(0);
            }
        }

        .cancel_order_button {
            height: 50px;
            border: none;
            font-size: 20px;
            color: #333333;
            &:hover, &:focus {
                // border-color: #c0c4cc;
                // color: #303133;
                // background-color: #f5f7fa;
            }
        }

        .delete_order_button {
            border-radius: 25px;
            border: 1px solid #0043E0;
            font-weight: 400;
            font-size: 20px;
            color: #0043E0;
            border-radius: 25px;
        }
    }
}

.sure_pay_content {
    padding: 10px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .p_text {
        font-size: 20px;
        color: #011E41;
        line-height: 33px;

        >span {
            font-size: 26px;
            color: #0043E0;
            line-height: 33px;
        }
    }

    .p_img {
        width: 266px;
        height: 266px;
        margin: 10px 0;

        .el-image {
            width: 100%;
            height: 100%;
        }
    }

    .p_text1 {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: 33px;
        display: flex;
        flex-flow: row;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            margin-left: 5px;
        }
    }
}

.cancel_pay_content {
    

    .cancel_text {
        font-size: 16px;
        color: #000000;
    }
    .cancel_text2 {
        font-size: 13px;
    }
}

.result-image {
    >>>.icon-warning {
        fill: red;
    }
}

// 响应式设计
@media (max-width: 640px) {
    .order_payment_container {
        margin-bottom: 20vw;

        .nav_box {
            padding: 2vw 1vw;
            font-size: 3.2vw;
        }

        .back_btn {
            font-size: 3.2vw;

            img {
                width: 3.8vw;
                margin-right: 0.5vw;
            }
        }

        .nav_header {
            .pc {
                display: none;
            }

            .back_btn {
                img {
                    display: none;
                }
            }

            .mo {
                display: block;
            }
        }

        .order_details_section {
            min-width: 100%;

            .section_header {
                // justify-content: center;
                height: 14vw;
                padding: 2.4vw;

                .exam_type_tag {
                    font-size: 3vw;
                }

                .section_title {
                    font-size: 3vw;
                    line-height: 3vw;
                }

                .payment_status {
                    font-size: 3vw;
                }
            }
        }

        .personal_info_section {
            padding: 2.4vw;

            .action_buttons {
                .info {
                    font-size: 4vw;
                }

                .info::before {
                    width: 1vw;
                    height: 5vw;
                }

                .edit_info_btn {
                    font-size: 4vw;

                    img {
                        width: 4.8vw;
                    }
                }
            }

            .info_table {
                display: flex;
                flex-direction: column;

                .table_pair {
                    grid-column: auto !important;
                    grid-row: auto !important;
                    border-right: none !important;
                    border-bottom: 1px solid #9AB0B2;

                    .table_cell {
                        padding: 2.2vw;

                        &.table_cell_label {
                            font-size: 3.2vw;
                            width: 32vw;
                            min-width: 0;
                        }

                        &.table_cell_value {
                            padding: 2.4vw 3vw;
                            font-size: 3.2vw;
                        }
                    }
                }

                .table_pair:last-child {
                    border-bottom: none;
                }
            }
        }

        .note_section {
            padding: 2.4vw;

            .note_img {
                img {
                    width: 28vw;
                    height: 28vw;
                }

                margin-right: 2vw;
            }

            .note_text {
                >span {
                    width: 100%;
                    font-size: 3.2vw;
                    padding: 0.8vw;
                    text-align: center;
                }

                font-size: 3vw;
            }
        }

        .payment_container {
            padding: 2.4vw;
            min-height: 80vw;
            width: 100%;

            .payment_title {
                font-size: 4vw;
                margin-bottom: 5vw;
            }

            .payment_title::after {
                width: 1vw;
                height: 5vw;
            }

            .fee_details {
                margin-bottom: 10vw;

                .fee_row {
                    margin-bottom: 3.8vw;

                    .fee_label {
                        font-size: 3.8vw;
                    }

                    .fee_value {
                        font-size: 4vw;
                    }
                }
            }

            .payment_tips {
                padding: 3vw 2.6vw;

                .tip_text {
                    font-size: 3.2vw;
                }
            }

            .payment_actions {
                .pay_now_button {
                    height: 13vw;
                    font-size: 4.2vw;
                }

                .cancel_order_button, .delete_order_button {
                    font-size: 4vw;
                }
            }
        }
    }

    .sure_pay_content {
        padding: 5vw;

        .p_text {
            font-size: 4.4vw;
            color: #011E41;

            >span {
                font-size: 5vw;
            }
        }

        .p_img {
            width: 58vw;
            height: 58vw;
            margin: 2vw auto;

            // border: 1px solid #011E41;
            img {
                width: 100%;
                height: 100%;
            }
        }

        .p_text1 {
            font-size: 3.2vw;

            img {
                width: 4vw;
                height: 4vw;
                margin-left: 1vw;
            }
        }
    }

    .cancel_pay_content {
        .cancel_text {
            font-size: 5vw;
        }

        .cancel_text1 {
            font-size: 3.4vw;
        }
        .cancel_text2 {
            font-size: 3vw;
        }
    }
}
</style>